<template>
	<div>
		<div v-if="!user.loggedIn" class="container">
			<div class="row justify-content-center">
				<div class="col-md-8">
					<div class="card">
						<div class="card-header">Login</div>
						<div class="card-body">
						<div v-if="error" class="alert alert-danger">{{error}}</div>
							<form action="#" @submit.prevent="submit">
								<div class="form-group row">
								<label for="email" class="col-md-4 col-form-label text-md-right">Email</label>

									<div class="col-md-6">
										<input
										id="email"
										type="email"
										class="form-control"
										name="email"
										value
										required
										autofocus
										v-model="form.email"
										/>
									</div>
								</div>

								<div class="form-group row">
									<label for="password" class="col-md-4 col-form-label text-md-right">Password</label>

									<div class="col-md-6">
										<input
										id="password"
										type="password"
										class="form-control"
										name="password"
										required
										v-model="form.password"
										/>
									</div>
								</div>

								<div class="form-group row mb-0">
									<div class="col-md-8 offset-md-4">
										<button type="submit" class="btn btn-primary">Login</button>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div v-if="user.loggedIn">
			<Simulateur class="simulateur"></Simulateur>
		</div>

		<template v-if="user.loggedIn">
			<div class="nav-item">{{user.data.email}}</div>
			<li class="nav-item">
				<button><a class="nav-link" @click.prevent="signOut">Sign out</a></button>
			</li>
		</template>


	</div>
</template>
<script>
import firebase from "firebase";
import { mapGetters } from "vuex";
import Simulateur from './Simulateur.vue'

export default {
	name: 'Admin',
	components:{Simulateur},
	data() {
		return {
			form: {
				email: "",
				password: ""
			},
			error: null
		};
	},
	computed: {
    	...mapGetters({
		// map `this.user` to `this.$store.getters.user`
      		user: "user"
    	})
  	},
	methods: {
		submit() {
			firebase
			.auth()
			.signInWithEmailAndPassword(this.form.email, this.form.password)
			.then(data => {
				// console.log(this.user)
			})
			.catch(err => {
				this.error = err.message;
			});
		},
		signOut() {
	    	firebase
	        .auth()
	        .signOut()
	        .then(() => {
	        	// console.log("logout")
	        });
	    }
	}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue